export function checkPassWordEntropy(password) {
	/*
		Calculate the entropy bits of a password.
		
		40-55 bits: Very Weak
		56-64 bits: Weak; should keep out most people
		65-80 bits: Moderate; fairly secure passwords
		81-127 bits: Strong; can be good for guarding financial information
		128+ bits: Very Strong; overkill for most purposes
		*/

	// Define the character sets
	const lowerCase = new Set("abcdefghijklmnopqrstuvwxyz");
	const upperCase = new Set("ABCDEFGHIJKLMNOPQRSTUVWXYZ");
	const digits = new Set("0123456789");
	const specialCharacters = new Set("!@#$%^&*()-_=+[]{}|;:'\",.<>?/`~");

	// Determine the character set size
	let charSetSize = 0;

	if ([...password].some(char => lowerCase.has(char))) {
		charSetSize += lowerCase.size;
	}
	if ([...password].some(char => upperCase.has(char))) {
		charSetSize += upperCase.size;
	}
	if ([...password].some(char => digits.has(char))) {
		charSetSize += digits.size;
	}
	if ([...password].some(char => specialCharacters.has(char))) {
		charSetSize += specialCharacters.size;
	}

	// Calculate entropy
	const entropy = password.length * Math.log2(charSetSize);
	return entropy;
}

export function checkPassWordCharacters(password) {
	if (!password) {
		throw new Error("Password is empty.");
	}

	const lowerCaseRegex = ".*[a-z]";
	const upperCaseRegex = "(?=.*[A-Z])";
	const symbolsRegex = "(?=.*[!#$%&'\"()*+,-./:;<=>?@\\[\\]^_`{|}~])";
	const numericRegex = "(?=.*[0-9])";

	let strength = {
		id: null,
		value: null,
		length: null,
		contains: [],
	};

	// Default
	let passwordContains = [];

	if (new RegExp(`^${lowerCaseRegex}`).test(password)) {
		passwordContains = [
			...passwordContains,
			{
				message: "lowercase",
			},
		];
	}

	if (new RegExp(`^${upperCaseRegex}`).test(password)) {
		passwordContains = [
			...passwordContains,
			{
				message: "uppercase",
			},
		];
	}

	if (new RegExp(`^${symbolsRegex}`).test(password)) {
		passwordContains = [
			...passwordContains,
			{
				message: "symbol",
			},
		];
	}

	if (new RegExp(`^${numericRegex}`).test(password)) {
		passwordContains = [
			...passwordContains,
			{
				message: "number",
			},
		];
	}

	const strongRegex = new RegExp(
		`^${lowerCaseRegex}${upperCaseRegex}${numericRegex}${symbolsRegex}(?=.{8,})`
	);
	const mediumRegex = new RegExp(
		`^((${lowerCaseRegex}${upperCaseRegex})|(${lowerCaseRegex}${numericRegex})|(${upperCaseRegex}${numericRegex})|(${upperCaseRegex}${symbolsRegex})|(${lowerCaseRegex}${symbolsRegex})|(${numericRegex}${symbolsRegex}))(?=.{6,})`
	);

	if (strongRegex.test(password)) {
		strength = {
			id: 2,
			value: "Strong",
		};
	} else if (mediumRegex.test(password)) {
		strength = {
			id: 1,
			value: "Medium",
		};
	} else {
		strength = {
			id: 0,
			value: "Weak",
		};
	}
	strength.length = password.length;
	strength.contains = passwordContains;
	return strength;
}